/**
 * Application settings capabilities confirmed against arkhrmsapi.
 *
 * Backend-backed:
 * - GET/PUT /notifications/preferences...
 * - GET /organization (SETTINGS_VIEW) — org timezone / date / time defaults (read-only here)
 * - GET/PUT /hr-policy-configurations/late-arrival (SETTINGS_VIEW / SETTINGS_UPDATE)
 * - Kiosk registration / activation admin APIs (SETTINGS_VIEW / SETTINGS_UPDATE)
 *   — managed under Organization → Kiosks
 *
 * Local-only (no user preference APIs):
 * - Theme
 *
 * Not available:
 * - User language
 * - User timezone override
 * - User date/time format override
 * - Help / support / privacy / terms URLs
 */
export const SETTINGS_CAPABILITIES = {
  themeLocal: true,
  notificationPreferences: true,
  organizationLocalizationReadOnly: true,
  lateArrivalConfiguration: true,
  kioskManagement: true,
  userLanguage: false,
  userTimezone: false,
  userDateFormat: false,
  userTimeFormat: false,
  helpLinks: false,
} as const;
